module.exports = __webpack_public_path__ + "img/seating-gallery-2.7c4a6521.jpg";